import axios from 'axios';

const API_BASE_CAMPAIGNS = process.env.REACT_APP_TEMPLATE_DELIVERY_SERVICE_URI + '/campaigns';

export const apiCampaigns = axios.create({
  baseURL: API_BASE_CAMPAIGNS,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});